import React from 'react'

import {
  Sheet,
  SheetOverlay,
  SheetContent,
  SheetTitle,
  SheetBody,
} from '@wartek-id/sheet'
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogHeader,
  DialogFooter,
} from '@wartek-id/dialog'
import { Icon } from '@wartek-id/icon'

type ResponsiveSheetProps = {
  isDesktop: boolean
  isOpen: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
  desktopFooter?: React.ReactNode
}

const ResponsiveSheet = ({
  isDesktop,
  isOpen,
  title,
  onClose,
  children,
  desktopFooter,
}: ResponsiveSheetProps) => {
  if (isDesktop) {
    return (
      <Dialog isOpen={isOpen} onClose={onClose} customSize={480}>
        <DialogOverlay />
        <DialogContent className="overflow-hidden">
          <DialogHeader title={title} className="p-4 bg-white" />
          <div className="p-4 bg-white overflow-y-auto max-h-[70vh]">
            {children}
          </div>
          {desktopFooter && (
            <DialogFooter className="p-4 bg-white">
              {desktopFooter}
            </DialogFooter>
          )}
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Sheet
      type="modal"
      isOpen={isOpen}
      autoFocus
      closeOnOverlayClick
      position="bottom"
      returnFocus
      onClose={onClose}
    >
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto">
        <SheetTitle className="flex items-center">
          <div className="mr-4" onClick={onClose}>
            <Icon>arrow_back</Icon>
          </div>
          <div className="flex-1 text-lg font-semibold">{title}</div>
        </SheetTitle>
        <SheetBody className="p-4">{children}</SheetBody>
      </SheetContent>
    </Sheet>
  )
}

export default ResponsiveSheet
